import { Link } from 'react-router-dom';

const ComponentNotFound = () => (
  <div style={{ padding: '2rem' }}>
    <h2>Component not found</h2>
    <p>
      The selected component could not be found. It may have been removed or the
      link is no longer valid.
    </p>
    <Link to="/sia/components">Back to components</Link>
  </div>
);

export default ComponentNotFound;
